// extracted by mini-css-extract-plugin
export var chevronIcon = "_d1-2";
export var teamName = "_d1-1";
export var teamSwitcherButton = "_d1-0";